(() => {
  // Background thumbnails have no native loading="lazy" equivalent.
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) return;
  const root = document.documentElement;
  root.setAttribute('data-ll-lazy-swatches', '');
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.setAttribute('data-ll-swatch-ready', '');
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '400px' });

  const observeCards = scope => {
    if (!(scope instanceof Element)) return;
    const cards = scope.matches('.grid-product') ? [scope] : scope.querySelectorAll('.grid-product');
    for (const card of cards) {
      if (seen.has(card)) continue;
      seen.add(card);
      observer.observe(card);
    }
  };

  const start = () => {
    const main = document.getElementById('MainContent');
    if (!main) {
      root.removeAttribute('data-ll-lazy-swatches');
      return;
    }
    observeCards(main);
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) observeCards(node);
      }
    }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
